// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screenSubContainer{
    margin-bottom: 20px;
}
.list-agreements-dashboard{
    position: relative;
}
.list-agreements-dashboard .container-scroll{
    top: 0px;
    height: 400px;
}
#dashboard {
    max-height: calc(100vh - 56px);
    min-height: calc(100vh - 56px);
}`, "",{"version":3,"sources":["webpack://./src/views/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,QAAQ;IACR,aAAa;AACjB;AACA;IACI,8BAA8B;IAC9B,8BAA8B;AAClC","sourcesContent":[".screenSubContainer{\n    margin-bottom: 20px;\n}\n.list-agreements-dashboard{\n    position: relative;\n}\n.list-agreements-dashboard .container-scroll{\n    top: 0px;\n    height: 400px;\n}\n#dashboard {\n    max-height: calc(100vh - 56px);\n    min-height: calc(100vh - 56px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
